import { ConditionalWrapper } from '@cian/conditional-component';
import * as React from 'react';

import { IOffersFeedProps } from '../../../types';
import { ScrollableWrapper } from '../../commonComponents';
import { NarrowOfferRow } from '../NarrowOfferRow';
import * as styles from './styles.css';

type TNarrowOffersFeedProps = Omit<IOffersFeedProps, 'feedViewState'>;

export const NarrowOffersFeed: React.VFC<TNarrowOffersFeedProps> = ({
  scrollable,
  data,
  onOfferClick,
  showMoreBtn,
  selectable,
  activeOfferId,
  viewedOffers,
}) => {
  return (
    <ConditionalWrapper if={Boolean(scrollable)} ThenComponent={ScrollableWrapper}>
      <div className={styles['content']}>
        {data.map(offer => (
          <NarrowOfferRow
            key={offer.id}
            data={offer}
            onClick={() => onOfferClick(offer.id)}
            testId={`offers_history_listing_item_${offer.id}`}
            selectable={selectable}
            isActive={offer.id === activeOfferId}
            isViewed={viewedOffers.includes(offer.id)}
          />
        ))}
        {showMoreBtn}
      </div>
    </ConditionalWrapper>
  );
};
